import React, { useEffect, useState } from 'react';
import { api } from '../../services/api';
import styles from './PdfExports.module.css';

/**
 * "אישורים לבנק" — history of every PDF export (transfer batch) sent to the bank.
 * Shows date, who created it, total amount, number of lines, and lets you view the PDF.
 */
export default function PdfExportsPage({ user }) {
  const [exports, setExports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [opening, setOpening] = useState(null);

  useEffect(() => {
    api.getPdfExports(user.credential)
      .then(setExports)
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [user.credential]);

  const openPdf = async (id) => {
    setOpening(id);
    try {
      const { url } = await api.getPdfExportUrl(user.credential, id);
      window.open(url, '_blank');
    } catch (e) {
      alert('לא ניתן לפתוח את הקובץ');
    } finally {
      setOpening(null);
    }
  };

  const formatAmount = (n) => `₪${Number(n).toLocaleString('he-IL', { minimumFractionDigits: 0 })}`;
  const formatDateTime = (iso) => new Date(iso).toLocaleString('he-IL', {
    day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit',
  });

  return (
    <div className={styles.container}>
      <h2>אישורים לבנק</h2>
      <p className={styles.sub}>כל אצווה שנשלחה לבנק — מתי, מה היה בה, וקישור ל-PDF</p>

      {loading && <p className={styles.empty}>טוען...</p>}
      {!loading && exports.length === 0 && <p className={styles.empty}>עדיין לא בוצעו יצואים.</p>}

      {!loading && exports.length > 0 && (
        <div className={styles.list}>
          {exports.map((e) => (
            <div key={e.id} className={styles.card}>
              <div className={styles.cardMain}>
                <div className={styles.date}>{formatDateTime(e.createdAt)}</div>
                <div className={styles.amount}>{formatAmount(e.totalAmount)}</div>
              </div>
              <div className={styles.cardMeta}>
                <span>{e.lineCount} העברות</span>
                {e.createdByName && <span> · אושר ע"י {e.createdByName}</span>}
              </div>
              <div className={styles.cardActions}>
                {e.hasFile ? (
                  <button className={styles.viewBtn} onClick={() => openPdf(e.id)} disabled={opening === e.id}>
                    {opening === e.id ? 'פותח...' : '📄 צפה ב-PDF'}
                  </button>
                ) : (
                  <span className={styles.noFile}>אין קובץ שמור</span>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
